(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-featured-slider')) {
    class CollectionFeaturedSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-featured-track]');
        this.prev = this.querySelector('[data-featured-prev]');
        this.next = this.querySelector('[data-featured-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.scrollByPage(-1));
        this.next.addEventListener('click', () => this.scrollByPage(1));
        this.track.addEventListener('scroll', this.update, { passive: true });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      scrollByPage(direction) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: direction * step * visible, behavior: 'smooth' });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const overflowing = maxScroll > 1;
        this.prev.hidden = !overflowing;
        this.next.hidden = !overflowing;
        this.prev.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
      }
    }

    customElements.define('collection-featured-slider', CollectionFeaturedSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-pais"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (event.target.matches('.mr-country__select')) {
      event.target.form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
